import React from 'react'
import emailjs from "emailjs-com";
const initForm = {
  name: "",
  email: "",
  message: ""

}
function ContactForm({ animate, handleRobotText }) {
  const [form, setForm] = React.useState({ ...initForm });
  const [message, setMessage] = React.useState("");
  const [emailState, setEmailState] = React.useState(false);
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  function sendEmail(e) {
    e.preventDefault();
    setEmailState(true);
    emailjs
      .send(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        form,
        process.env.REACT_APP_EMAIL_USER_ID
      )
      .then(
        (result) => {
          setMessage("Thank you check you Email");
          handleRobotText("Thank you check you Email");
          setTimeout(() => {
            setMessage("");
            setForm({ ...initForm });
            setEmailState(false);
          }, 3000);
        },
        (error) => {
          handleRobotText(error.text);
        }
      );
  }

  return (
    <form
      onSubmit={sendEmail}
      className={`contactForm glass flexBox ${animate && "animate"}`}
      onMouseEnter={()=>handleRobotText("Do you want to send a message...?")}
    >
      <small>Get in touch</small>
      <input
        type="text"
        name="name"
        value={form.name}
        placeholder="Name"
        required
        onChange={handleChange}
      />
      <input
        type="email"
        name="email"
        value={form.email}
        placeholder="Email"
        required
        onChange={handleChange}
      />
      <textarea
        type="text"
        name="message"
        value={form.message}
        placeholder="Message"
        required
        onChange={handleChange}
      />
      <div className="contactSubmit flexBox">
        <small>{message}</small>
        <button disabled={emailState} type="submit">
          Send
        </button>
      </div>
    </form>
  );
}

export default ContactForm
